import React, { useContext, useEffect, useState } from 'react';
import "./LoginStyles.scss";
import { classNames } from 'primereact/utils';
import { ProgressSpinner } from 'primereact/progressspinner';
import { AuthContext } from '../../Context/AuthContext/AuthContext';
import { Fieldset } from 'primereact/fieldset';
import { useForm } from '../../Hooks/useForm';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { loginUser } from '../../API/IT/Users/UserRequests.js'; 
import { ConfigContext } from '../../Context/ConfigContext/ConfigContext.js';
import { getLabel } from '../../Services/Language/LanguageService';
import { baseLang } from '../../Lang/BaseLang';
import { setTitlePage } from '../../Services/Config/ConfigService';


export const LoginScreen = () => {
    const { values, handleInputChange, error, setError } = useForm({
        user: '',
        password: ''
    });

    const { config } = useContext(ConfigContext);
    const [showMessage, setShowMessage] = useState(false); // Mantén el estado showMessage
    const [loading, setLoading] = useState(false);
    const { signIn } = useContext(AuthContext);

    const login = async () => {
        if (values.user && values.password) {
            setLoading(true);
            const res = await loginUser(values.user, values.password);
            setLoading(false);
            if (res.auth === true) {
                localStorage.setItem(process.env.REACT_APP_StorageUser, JSON.stringify({...res.user, Token: res.token}))
                localStorage.setItem(process.env.REACT_APP_StorageToken, res.token)
                signIn(res.user); // Llama a la función signIn del contexto de autenticación
                console.log('Inicio de sesión exitoso');
                setShowMessage(false); // Oculta el mensaje en la interfaz
                const ultimaUrl = localStorage.getItem('ultimaUrl');
                if(ultimaUrl){
                    window.location.href = ultimaUrl
                }else{
                    localStorage.removeItem('ultimaUrl');
                    window.location.href = window.location.origin + `${process.env.REACT_APP_ENV}/Home`
                }
            } else {
                console.log('Credenciales incorrectas');
                setError('login');
                setShowMessage(true); // Muestra el mensaje en la interfaz
            }
        } else {
            console.log('Credenciales incorrectas');
            setError('params')
            setShowMessage(true); // Muestra el mensaje en la interfaz
        }
    }

    useEffect(() => {
        setTitlePage('Login');
    }, []);

    const LogoEmpresa = (
        <React.Fragment>
            <div className="fila">
                <div className="">
                    <img src={process.env.REACT_APP_Logo_Primario_H_B64} alt="" className="login__empresa-logo" />
                </div>
            </div>
        </React.Fragment>
    );

    return (
        <div style={{ backgroundPosition: 'center', backgroundImage: `url(${process.env.REACT_APP_FONDO_LOGO})` }} className="login__contenedor-imagen">
            <div className="login__contenedor-formulario" >
                <div className={classNames("progressSpinner-container spinner-login", { 'isVisible': loading })}>
                    <ProgressSpinner />
                </div>

                <Fieldset legend={LogoEmpresa}>
                    <div className="p-lid login_formulario">
                        <div className="p-inputgroup">
                            <span className="p-inputgroup-addon">
                                <i className="pi pi-user"></i>
                            </span>
                            <InputText
                                id="user"
                                name="user"
                                placeholder={getLabel(baseLang, 'user', config.language)}
                                value={values.user}
                                onChange={handleInputChange}
                                autoComplete="new-password"
                            />
                        </div>
                        {error.user && <small className="p-error">{error.user}</small>}
                        <div className="p-inputgroup login_input-password ">
                            <span className="p-inputgroup-addon">
                                <i className="pi pi-lock"></i>
                            </span>
                            <Password
                                id="password"
                                name="password"
                                placeholder={getLabel(baseLang, 'password', config.language)}
                                value={values.password}
                                onChange={handleInputChange}
                                onKeyDown={e => e.key === 'Enter' && login()}
                                toggleMask={true}
                                feedback={false}
                                autoComplete="new-password"
                            />
                        </div>
                        {error.password && <small className="p-error">{error.password}</small>}
                        {showMessage && <div className="p-error">{getLabel(baseLang, 'badCredentials', config.language)}</div>}
                        <div className="p-inputgroup">
                            <div className="p-inputgroup" style={{ backgroundColor: 10 }}>
                                <Button type="button" className="p-button-Primary" width='100% '
                                    label={getLabel(baseLang, 'login', config.language)}
                                    style={{ marginTop: 10, width: "100%" }}
                                    onClick={login} disabled={loading}
                                />
                            </div>
                            <br />
                        </div>
                    </div>
                </Fieldset>
            </div>
        </div>
    );
};
